import React from "react"

export const ContractIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16.808" height="17.693" viewBox="0 0 16.808 17.693">
            <path id="Path_101921" data-name="Path 101921" d="M37.4,28,35.22,30.115l-3.01-.426-.525,3L29,34.112l1.335,2.734L29,39.58l2.686,1.426.525,3,3.01-.426L37.4,45.693l2.184-2.115L42.6,44l.525-3,2.685-1.426-1.335-2.734,1.335-2.734-2.686-1.426-.525-3-3.01.426L37.4,28Z" transform="translate(-29 -28)" fill="#fff" />
        </svg>

    )
}